import Logger from 'Common/logs/Logger';
import BrowserTransport from 'Browser/logs/BrowserTransport';
import BrowserFormat from 'Browser/logs/BrowserFormat';
import { createViteBrowserRouter, createBrowserRouter } from 'Shared/Root';
import { hydrate, render } from 'solid-js/web';
import { BuildBasics } from 'Common/BuildBasics';
import { SiteBasics } from 'Common/SiteBasics';
import { User } from 'Browser/User';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from 'Server/rpc/calls';


export class Browser
{
	constructor(
		private build:BuildBasics,
		private site:SiteBasics,
		private user:User
	)
	{}

	async run()
	{
//XXX perhaps raise the level for production   
		window.log = new Logger(undefined);
		log.add(new BrowserTransport(),new BrowserFormat(),'debug');

		const basicData = {
			build: this.build,
			site: this.site,
			user: this.user,
			server: initTrpcClient()
		};

		if (window.useVite) 
			render(createViteBrowserRouter(basicData), document.getElementById('root') as HTMLElement);
		else
			hydrate(createBrowserRouter(basicData), document);
	}
}

export function initTrpcClient()
{
	return createTRPCClient<AppRouter>({
		links: [
//			httpLink({url: '/_rpc' }),   //XXX simpler to debug

			httpBatchLink({
				url: '/_rpc'
			}),
		],
	});
}

